<template>
    <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        class="pb-5 mt-0"
    >
        <v-row no-gutters justify="center" align=center>
            <v-col cols="12" align="center" class="my-5">
                <img :height="$vuetify.breakpoint.sm ? '300px' : '100px'" width="auto" src="@/assets/lokroi/logo-lokroi.svg">
                <v-row class="px-2 mx-0" no-gutters justify="start">
                    <v-col cols=12 align=center style="z-index: 100000000;">
                        <div style="font-size: 30px; font-weight: 600;">ΑΙΤΗΣΗ</div>
                        <div style="font-size: 20px;">συμμετοχής στο πρόγραμμα Κάρτας Δημότη Δήμου Λοκρών για επιχειρήσεις</div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="px-2 mx-0 mt-10" justify="start">
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" align=start>
                <h3>*Επώνυμο</h3>
                <v-text-field v-model="form.lastName" color="#f38d1e" required :rules="[v => !!v || 'Υποχρεωτικό πεδίο']">

                </v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" align=start>
                <h3>*Όνομα</h3>
                <v-text-field v-model="form.firstName" color="#f38d1e" required :rules="[v => !!v || 'Υποχρεωτικό πεδίο']">

                </v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" align=start>
                <h3>*Επωνυμία επιχείρησης</h3>
                <v-text-field v-model="form.title" hide-details color="#f38d1e" required :rules="[v => !!v || 'Υποχρεωτικό πεδίο']">
                </v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" align=start>
                <h3>*Email</h3>
                <v-text-field v-model="form.email" color="#f38d1e" required :rules="[v => !!v || 'Υποχρεωτικό πεδίο']">

                </v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6" align=start>
                <h3>*Κινητό</h3>
                <v-text-field v-model="form.phone" required color="#f38d1e" :rules="[v => !!v || 'Υποχρεωτικό πεδίο']">

                </v-text-field>
            </v-col>
            <v-col cols=12 align=start class="my-0 py-0">
                <v-checkbox
                    dense
                    v-model="form.newsletter"
                    :rules="[v => !!v || 'Πρέπει να αποδεχτείτε τους όρους για να συνεχίσετε!']"
                    label="Συναινώ στην χρήση των στοιχείων μου για την επικοινωνία σχετικά με κάθε είδους ενημέρωση ή εκδήλωση, από τον Δήμο Λοκρών ή τον Π.Α.Ρ.Ο.Ν., μέσω e-mail, sms ή τηλεφώνου."
                />
            </v-col>
            <v-col cols=12 align=start class="">
                <h4>Ενημέρωση επεξεργασίας δεδομένων προσωπικού χαρακτήρα:</h4>
                <div class="pt-5" style="font-size: 16px; line-height: 1.5;">
                    Ενημερώθηκα ότι: το όνομά μου το επίθετο μου, το e-mail μου, το κινητό μου τηλέφωνο θα κοινοποιηθούν στον εκτελούντα την επεξεργασία Πολιτιστικό 
                    Οργανισμό Π.Α.Ρ.Ο.Ν., για τον σκοπό της συμμετοχής της επιχειρησής μου στο πρόγραμμα Κάρτα Δημότη Λοκρών. Είμαι ενήμερος για την τήρηση και 
                    επεξεργασία των δεδομένων μου καθώς και για τα δικαιώματά μου σύμφωνα με 
                    τις διατάξεις του Γενικού Κανονισμού για την Προστασία Δεδομένων 679/2016/ ΕΕ και του ν.4624/2019 και αποδέχομαι την χρήση 
                    των δηλωθέντων στην παρούσα αίτηση προσωπικών δεδομένων μου από τον Π.Α.Ρ.Ο.Ν. για το σκοπό της αξιολόγησης της σχετικής 
                    αίτησής μου, της εξυπηρέτησης και της εν γένει ενημερώσής μου σε σχέση με το υποβληθέν διά της παρούσης αίτημα μου.
                </div>
            </v-col>
            <v-col cols=12 align=center class="my-5">
                <v-btn x-large style="color: white;" color="#1b2f5a" :disabled="!form.newsletter" @click="validate">
                    Υποβολή
                </v-btn>
            </v-col>
        </v-row>
        <alert :show-alert="showAlert" :message="message" :type="type" @closeAlert="closeAlert()"/>
    </v-form>
</template>

<script>
    import partnerService from "@/services/partner"
    import Alert from '@/components/Alert'

    export default {
        components: { Alert },
        data: () => ({
            terms: false,
            readOnly: false,
            showAlert: false,
            type: null,
            message: null,
            valid: true,
            street: null,
            streetNumber: null,
            region: null,
            form: {},
            teams: [],
            dealers: [],
            modelConfig: {
                type: 'String',
                mask: 'yyyy-MM-DD'
            },
        }),
        created() {
        },
        methods: {
            closeAlert() {
                this.showAlert = false
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { 
                    this.showAlert = false
                    if (type === 'success') {
                        this.$router.push({name: 'Homepage'})
                    }
                }, 10000)
            },
            validate() {
                this.form.dealer = 77 // Souli
                if (this.$refs.form.validate()) {
                    partnerService.register(this.form).then(() => {
                        this.form = {}
                        this.terms = false
                        this.setAlert('Η εγγραφή σας πραγματοποιήθηκε επιτυχώς. Θα ενημερωθείτε εκ νέου με την ολοκλήρωση της διαδικασίας μέσω των στοιχείων που έχετε συμπληρώσει.', 'success')
                    }).catch(() => {
                        this.setAlert('Κάτι πήγε στραβά! Παρακαλώ προσπαθήστε εκ νέου αργότερα.', 'error')
                    })
                } else {
                    this.setAlert('Παρακαλώ συμπληρώστε όλα τα υποχρεωτικά πεδία.', 'error')
                }
            },
            reset() {
                this.street = null
                this.streetNumber = null
                this.region = null
                this.$refs.form.reset()
            },
            resetValidation() {
                this.$refs.form.resetValidation()
            },
        },
    }
</script>